import {
  Component,
  Input,
  OnInit,
  OnDestroy,
  inject,
  input,
} from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  UntypedFormBuilder,
  Validators,
  UntypedFormArray,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { startWith, map, takeUntil } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';
import { ICustomer } from 'src/app/@interfaces/customer.interface';
import { IQuota } from 'src/app/@interfaces/quotation.interface';
import { QuotationsService } from 'src/app/@pages/quotations/quotations.service';
import { IWarehouse } from 'src/app/@interfaces/warehouse.interface';
import { NgxSpinnerService, NgxSpinnerModule } from 'ngx-spinner';
import { INotas } from '../../../../../../@interfaces/notas.interface';
import { CookieAuthService } from 'src/app/@shared/storage-variables/cookie-auth.service';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatOptionModule } from '@angular/material/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { AsyncPipe } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { NoteConcept } from '@shared-models';

@Component({
  selector: 'app-ver-credito',
  templateUrl: './ver-credito.component.html',
  styleUrls: ['./ver-credito.component.css'],
  imports: [
    MatDialogModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    MatOptionModule,
    MatDatepickerModule,
    RouterLink,
    MatIconModule,
    MatButtonModule,
    NgxSpinnerModule,
    AsyncPipe,
    TranslatePipe,
  ],
})
export class VerCreditoComponent implements OnInit, OnDestroy {
  private spinnerService = inject(NgxSpinnerService);
  dialog = inject(MatDialog);
  private quotationservice = inject(QuotationsService);
  private fb = inject(UntypedFormBuilder);
  private cookieAuthService = inject(CookieAuthService);
  private translate = inject(TranslateService);

  @Input() id_fact: number = 0;
  totalQuot: number = 0;
  newCustomer: UntypedFormControl = this.fb.control('', Validators.required);
  registerForm: UntypedFormGroup = this.fb.group({
    itemRows: this.fb.array(
      [
        this.fb.group({
          aidi: [0],
          note_fact: [],
          codigo: [, Validators.required],
          tipo_nota: [, Validators.required],
          concepto: [, Validators.required],
          precio: [, Validators.required],
          subtotal: [0],
          total: ['', Validators.required],
          cude: [],
          date: [, Validators.required],
          dueDate: [, Validators.required],
        }),
      ],
      Validators.required,
    ),
  });
  get rowsArr() {
    return this.registerForm.get('itemRows') as UntypedFormArray;
  }
  QuotationToModify = {} as IQuota;
  noteToSee = {} as INotas;
  filteredOptionsCustomer: Observable<ICustomer[]> | undefined;
  idsArray = [
    {
      id: [],
    },
  ];
  CustomersList: Array<ICustomer> = [];
  WarehouseList: Array<IWarehouse> = [];
  unsubscribe$ = new Subject<void>();
  companyId = '';
  concepts = input<NoteConcept[]>();

  async ngOnInit(): Promise<void> {
    this.getAuthValues();
    this.filteredValues();
    this.QuotationToModify = await this.getQuotation();
    this.setQuotation(this.QuotationToModify);
  }

  getAuthValues() {
    const company = this.cookieAuthService.getCompanyObject;
    this.companyId = company!.Id_company!.toString();
  }

  filteredValues() {
    this.filteredOptionsCustomer = this.newCustomer.valueChanges.pipe(
      startWith(''),
      map((value) => this._filterC(value)),
    );
  }

  getQuotation() {
    return new Promise<IQuota>((resolve, reject) => {
      this.quotationservice
        .getQuotation(this.id_fact)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((result) => {
          resolve(result);
        });
    });
  }

  setQuotation(quotation: IQuota) {
    const { cliente } = quotation;
    this.setCredit(quotation, cliente);
  }

  setCredit(quotation: IQuota, cliente: ICustomer) {
    this.quotationservice
      .getCredito(parseInt(this.id_fact.toString()))
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((result) => {
        this.noteToSee = result;
        this.editQuotation(quotation, cliente, this.noteToSee);
      });
  }

  editQuotation(quotation: any, customer: ICustomer, notas: any) {
    this.registerForm.patchValue({
      tax: quotation.tax,
    });
    this.newCustomer.setValue(customer);
    this.registerForm.setControl('itemRows', this.setVenta(notas));
  }

  setVenta(notas: any): UntypedFormArray {
    const formArray = new UntypedFormArray([]);
    for (let index = 0; index < notas.length; index++) {
      this.idsArray[0].id = notas[index].id_nota;
      const concept = this.concepts()?.map((concept) => {
        if (concept.code === notas[index].concepto) {
          return concept.description;
        } else {
          return '';
        }
      });
      formArray.push(
        this.fb.group({
          aidi: notas[index].id_nota,
          note_fact: notas[index].note_fact,
          tipo_nota: notas[index].tipo_nota,
          concepto: concept?.join(''),
          precio: notas[index].precio,
          subtotal: notas[index].subtotal,
          total: notas[index].total,
          cude:
            notas[index].billyNotes[0].cude ||
            this.translate.instant('Not Found'),
          date: notas[index].createAt,
          dueDate: notas[index].dueDate,
        }),
      );
    }
    return formArray;
  }

  private _filterC(value: string): ICustomer[] {
    const filterValueC = value.toString().toLowerCase();
    return this.CustomersList.filter(
      (option) =>
        option.doc_nit.toLowerCase().toString().includes(filterValueC) ||
        option.nombre.toLowerCase().toString().includes(filterValueC),
    );
  }

  displayFnCustomer(customer: any) {
    return customer && customer ? customer.nombre : undefined;
  }

  closeDialog() {
    this.dialog.closeAll();
  }

  spinner(): void {
    this.spinnerService.show();
    setTimeout(() => {
      this.spinnerService.hide();
    }, 3000);
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
